import { DeleteButton } from '@common/components/forms/controls';
import { IAuthRoleModel } from '@common/models/Security/AuthRoleModel';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { UserProfileRolesModalAdd } from './UserProfileRolesModalAdd';
import { UserProfileRolesModalDelete } from './UserProfileRolesModalDelete';
import { UserStore } from './UserStore';

export interface IUserProfileRolesProps {
    store: UserStore;
    readOnly?: boolean;
}

export const UserProfileRoles = observer(({ store, readOnly }: IUserProfileRolesProps) => {
    const [availableRoles, setAvailableRoles] = useState<IAuthRoleModel[]>([]);
    const [roleToDelete, setRoleToDelete] = useState<IAuthRoleModel | undefined>(undefined);

    const clearModals = () => {
        setAvailableRoles([]);
        setRoleToDelete(undefined);
    }
    const onAddRole = (roleIds: number[]) => {
        clearModals();
        store.addRoles(roleIds);
    }
    const onDeleteRole = (role: IAuthRoleModel) => {
        clearModals();
        store.deleteRole(role);
    }

    const hasRoles = store.assignedRoles.length > 0;

    return (<>
        <Row>
            {!hasRoles &&
                <p><em>No roles have been assigned to this user.</em></p>
            }
            {hasRoles &&
                <ul className="list-group">
                    {store.implicitRoles.map((r) =>
                        <li className="list-group-item no-border" key={r.authRoleId}>
                            {r.description} <strong>(Primary)</strong>
                        </li>)}
                    {store.explicitRoles.map((r) =>
                        <li className="list-group-item no-border" key={r.authRoleId}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                {r.description}
                                {!readOnly && store.isActive &&
                                    <DeleteButton aria-label={`delete ${r.description} role`} onClick={() => { setRoleToDelete(r) }} />
                                }
                            </div>
                        </li>)}
                </ul>
            }
        </Row>
        <Row className="pt-3">
            <Col xs={6}>
                {!readOnly && store.isActive &&
                    <Button
                        aria-label="add roles"
                        variant="outline-primary"
                        disabled={!store.availableRoles.length}
                        onClick={() => setAvailableRoles(store.availableRoles)}>Add New Roles</Button>
                }
            </Col>
        </Row>
        <UserProfileRolesModalAdd roles={availableRoles} onSubmit={onAddRole} onCancel={clearModals} />
        <UserProfileRolesModalDelete role={roleToDelete} onSubmit={onDeleteRole} onCancel={clearModals} />
    </>)
});
